const STORAGE_KEY = "telcofy.cookie-consent";

/**
 * Bump when the cookie policy materially changes — a stored decision from an
 * older version is treated as undecided, so visitors are asked again.
 */
const POLICY_VERSION = 1;

export const OPEN_SETTINGS_EVENT = "telcofy:open-cookie-settings";

/** Fallback when localStorage is unavailable (private mode, blocked storage). */
let memoryConsent = null;

/** "granted" | "denied" | null when the visitor has not decided yet. */
export function readConsent() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const stored = JSON.parse(raw);
      if (stored?.version !== POLICY_VERSION) return null;
      return stored.analytics ? "granted" : "denied";
    }
  } catch {
    // Storage unreadable — fall back to whatever was decided this session.
  }

  return memoryConsent;
}

export function writeConsent(granted) {
  memoryConsent = granted ? "granted" : "denied";

  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        version: POLICY_VERSION,
        analytics: granted,
        decidedAt: new Date().toISOString(),
      })
    );
  } catch {
    // Storage unwritable — the decision still holds for this page load.
  }
}

export function hasAnalyticsConsent() {
  return readConsent() === "granted";
}

/** Re-open the banner so a visitor can change or withdraw their decision. */
export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}
